import {
  AcceptedNetworksIcon,
  ClockIcon,
  DepositIcon,
  DocumentIcon,
  SettingsIcon,
  UserIcon, // ShareIcon,
  // VIPClubIcon,
  // BadgesIcon,
} from '@repo/icons';
import { type TranslationType } from '@/lib/types';

interface AccountMenuItem {
  href: string;
  name: string;
  count: number;
  matches: string[];
  notMatches?: string[];
  code: string;
  Icon: React.FC<{ className?: string }>;
}

export const getAccountMenuItems = (t: TranslationType) =>
  [
    {
      href: '/account/my-profile',
      matches: ['/account/my-profile'],
      name: t('my-profile'),
      Icon: UserIcon,
    },
    // {
    //   href: '/account/wallet',
    //   matches: ['/account/wallet'],
    //   name: t('wallet'),
    //   Icon: DepositIcon,
    // },
    {
      href: '/account/settings/general',
      matches: ['/account/settings/general', '/account/settings/responsible-gaming'],
      name: t('settings'),
      Icon: SettingsIcon,
    },
    // {
    //   href: '/account/vip-club',
    //   name: t('vip-club'),
    //   Icon: VIPClubIcon,
    // },
    // {
    //   href: '/account/badges',
    //   name: t('badges-and-xp'),
    //   Icon: BadgesIcon,
    // },
    {
      href: '/account/deposit',
      matches: ['/account/deposit'],
      name: t('deposit'),
      Icon: DepositIcon,
    },
    {
      href: '/account/withdraw',
      matches: ['/account/withdraw'],
      name: t('withdraw'),
      Icon: AcceptedNetworksIcon,
    },
    // {
    //   href: '/account/referrals',
    //   name: t('referrals'),
    //   Icon: ShareIcon,
    // },
    {
      href: '/account/bet-history/casino',
      matches: ['/account/bet-history/casino', '/account/bet-history/sports'],
      name: t('bet-history'),
      Icon: ClockIcon,
    },
    {
      href: '/account/transactions/deposits',
      matches: ['/account/transactions/deposits', '/account/transactions/withdrawals', '/account/transactions/bonuses'],
      name: t('transactions'),
      Icon: DocumentIcon,
    },
  ] as AccountMenuItem[];
